import Dexie from 'dexie';

export const db = new Dexie('myDatabase');
db.version(2).stores({
  plans: 'id, buffer, name, type',
});

export const loadedPlans = {};
